import windowViewport from './window-viewport';

var boundingOffset = function (element) {
    if (!element.getBoundingClientRect) {
        var viewport = windowViewport(element);
        return {
            bottom: viewport.height,
            left: 0,
            right: viewport.width,
            top: 0
        };
    }

    var ref = element.getBoundingClientRect();
    var bottom = ref.bottom;
    var left = ref.left;
    var right = ref.right;
    var top = ref.top;

    return {
        bottom: bottom,
        left: left,
        right: right,
        top: top
    };
};

export default boundingOffset;



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-popup-common/dist/es/bounding-offset.js
// module id = ../../../../@progress/kendo-popup-common/dist/es/bounding-offset.js
// module chunks = 3